// PDF annotation TypeScript interfaces for SpectReviews
// Compatible with react-pdf-highlighter-extended

// Position types for react-pdf-highlighter-extended
export interface ScaledPosition {
  boundingRect: {
    x1: number;
    y1: number;
    x2: number;
    y2: number;
    width: number;
    height: number;
    pageNumber: number;
  };
  rects: Array<{
    x1: number;
    y1: number;
    x2: number;
    y2: number;
    width: number;
    height: number;
    pageNumber: number;
  }>;
  pageNumber: number;
}

export interface Annotation {
  id: string;
  documentId: string;
  userId: string;
  page: number;
  type: 'text' | 'area' | 'general';
  position: ScaledPosition | null;
  comment: string;
  tags: string[];
  color: string;
  authorName?: string;  // Name of the commenter (for shared view)
  authorEmail?: string; // Email of the commenter (for shared view)
  createdAt: Date;
  updatedAt: Date;
}

export interface CreateAnnotationRequest {
  documentId: string;
  page: number;
  type: 'text' | 'area' | 'general';
  position: ScaledPosition | null;
  comment?: string;
  tags?: string[];
  color?: string;
  authorName?: string;  // Name of the commenter (for shared view)
  authorEmail?: string; // Email of the commenter (for shared view)
}

export interface UpdateAnnotationRequest {
  comment?: string;
  tags?: string[];
  color?: string;
}

// Highlight format compatible with react-pdf-highlighter-extended
export interface HighlightType {
  id: string;
  position: ScaledPosition;
  content: {
    text?: string;
    image?: string;
  };
  comment: {
    text: string;
    emoji: string;
  };
}

// Predefined colors for annotations
export const ANNOTATION_COLORS = {
  yellow: '#FFEB3B',
  blue: '#2196F3',
  green: '#4CAF50',
  pink: '#E91E63',
  orange: '#FF9800',
  purple: '#9C27B0',
} as const;

export type AnnotationColor = typeof ANNOTATION_COLORS[keyof typeof ANNOTATION_COLORS];
